import {MissingTranslationHandler, MissingTranslationHandlerParams} from "@ngx-translate/core";
import {Injectable} from "@angular/core";

@Injectable()
export class ColimoMissingTranslateHandler implements MissingTranslationHandler {

  public handle(params: MissingTranslationHandlerParams): string {
    return params.key ;
  }
}
